class MegaMenu extends HTMLElement {
    constructor() {
        super();
        this.headerWrapper        = document.querySelector('.header-wrapper')
        this.headerSection        = document.querySelector('#shopify-section-header');
        this.megaMenuImage        = this.querySelector('.megamenu__image');
        this.megaMenuImageWrapper = this.querySelector('.header__submenu-image');

        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('.header__menu-item')
            .forEach(menuItem => menuItem.addEventListener('mouseenter', this.onMenuItemEnter.bind(this)));
        this.headerWrapper.addEventListener('mouseleave', this.closeSubMenus.bind(this));
        this.querySelectorAll('.header__submenu-grandchild--item')
            .forEach(subMenuItem => subMenuItem.addEventListener('mouseenter', this.onSubmenuItemEnter.bind(this)));
        this.querySelectorAll('.header__submenu-child--item')
            .forEach(subMenuItem => subMenuItem.addEventListener('mouseenter', this.onSubmenuItemEnter.bind(this)));
    }

    onMenuItemEnter(event) {
        // Close Search modal
        const searchBox = document.querySelector('.header__icon-search .header__search');
        if(searchBox) {
            searchBox.querySelector('details').removeAttribute('open');
        }
        if(document.querySelector('.snize-ac-results')) {
            document.querySelector('.snize-ac-results').style.display = 'none';
        }
        const element  = event.target;

        const hasImage = element.hasAttribute('data-image-src');
        const parent   = element.closest('li');
        this.querySelectorAll('li').forEach(element => element.removeAttribute('open'));
        this.closeSubMenus(event);
        this.querySelector('ul').classList.add('active');
        parent.setAttribute('open', true);

        if(!element.getAttribute('href')) {
            this.headerSection.classList.add('menu-opening');
        }

        if (hasImage) {
            this.megaMenuImage.src    = element.getAttribute('data-image-src');
            this.megaMenuImage.srcset = element.getAttribute('data-image-src');
            this.megaMenuImage.alt    = element.getAttribute('data-image-alt');
            this.querySelector('.header__submenu-image--link').href = this.megaMenuImageWrapper.getAttribute('data-href');
            this.megaMenuImageWrapper.classList.remove('opacity-0');
        }
    }

    onSubmenuItemEnter(event) { // OK
        const element  = event.target;
        const hasImage = element.hasAttribute('data-image-src');
        let actualSubMenuContainer     = null;
        let actualMegaMenuImageWrapper = null;
        let actualMegaMenuImage        = null;
        if(element){
            actualSubMenuContainer = element.closest('.header__submenu__wrapper');
            if(actualSubMenuContainer){
                actualMegaMenuImageWrapper = actualSubMenuContainer.querySelector('.header__submenu-image');
                actualMegaMenuImage        = actualSubMenuContainer.querySelector('.header__submenu-image .megamenu__image');
            }
        }

        this.querySelectorAll('.header__submenu-grandchild--item').forEach(subMenuItem => subMenuItem.classList.remove('list-menu__item--active'));
        this.querySelectorAll('.header__submenu-child--item').forEach(subMenuItem => subMenuItem.classList.remove('list-menu__item--active'));
        element.classList.add('list-menu__item--active');

        if (hasImage) {
            actualMegaMenuImage.src    = element.getAttribute('data-image-src');
            actualMegaMenuImage.srcset = element.getAttribute('data-image-src');
            actualMegaMenuImage.alt    = element.getAttribute('data-image-alt');
            this.querySelector('.header__submenu-image--link').href = element.getAttribute('href');
            actualMegaMenuImageWrapper.classList.remove('opacity-0');
        } else if (actualMegaMenuImageWrapper.hasAttribute('data-image-src')) {
            actualMegaMenuImage.src    = actualMegaMenuImageWrapper.getAttribute('data-image-src');
            actualMegaMenuImage.srcset = actualMegaMenuImageWrapper.getAttribute('data-image-src');
            actualMegaMenuImage.alt    = actualMegaMenuImageWrapper.getAttribute('data-image-alt');
            this.querySelector('.header__submenu-image--link').href = actualMegaMenuImageWrapper.getAttribute('data-href');
            actualMegaMenuImageWrapper.classList.remove('opacity-0');
        } else {
            actualMegaMenuImageWrapper.classList.add('opacity-0');
        }

    }

    closeSubMenus() {
        this.querySelectorAll('li').forEach(menuWrapper => menuWrapper.removeAttribute('open'));
        document.querySelectorAll('.header__submenu-grandchild--item').forEach(subMenuItem => subMenuItem.classList.remove('list-menu__item--active'));
        this.headerSection.classList.remove('menu-opening');
        this.querySelector('ul').classList.remove('active');

        // Rebuilding intial state
        const subMenuContainers = this.querySelectorAll('.header__submenu__wrapper');
        subMenuContainers.forEach(function(subMenuContainer) {
            let megaMenuImageWrapper = subMenuContainer.querySelector('.header__submenu-image');
            let megaMenuImage        = subMenuContainer.querySelector('.header__submenu-image .megamenu__image');

            if (megaMenuImageWrapper && megaMenuImage && megaMenuImageWrapper.hasAttribute('data-image-src')) {
                megaMenuImage.src    = megaMenuImageWrapper.getAttribute('data-image-src');
                megaMenuImage.srcset = megaMenuImageWrapper.getAttribute('data-image-src');
                megaMenuImage.alt    = megaMenuImageWrapper.getAttribute('data-image-alt');
                subMenuContainer.querySelector('.header__submenu-image--link').href = megaMenuImageWrapper.getAttribute('data-href');
                megaMenuImageWrapper.classList.remove('opacity-0');
            }
        });
    }

}

customElements.define('mega-menu', MegaMenu);
